import React from "react";
import styled, { keyframes } from "react-emotion";
import { themeGet } from "styled-system";
import { FlexRow } from "../misc";

// TODO: do not couple overlay
// to specific component.
export const OrderOverlay = styled("div")`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  background-color: white;
  opacity: ${props => (props.isCreatingOrder ? 1 : 0)};
  z-index: 10;
  transition: opacity 0.2s linear;
`;

const load = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const OrderLoading = styled("div")`
  width: 40px;
  height: 40px;
  position: relative;
  margin: 25px;
`;

const bounce = keyframes`
  0%, 100% {
    transform: scale(0.0);
  } 50% {
    transform: scale(1.0);
  }
`;

const Bounce = styled("div")`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;

  &.second {
    animation-delay: -1s;
  }

  animation: ${bounce} 2s infinite ease-in-out;
`;

const TealBounce = styled(Bounce)`
  background-color: ${themeGet("colors.teal")};
`;

const BlueDarkerBounce = styled(Bounce)`
  background-color: ${themeGet("colors.blueDarker")};
`;

export const OrderSpinner = () => (
  <OrderLoading>
    <TealBounce />
    <TealBounce className="second" />
  </OrderLoading>
);

// TODO: do not couple heading
// to specific component.
// @letter-spacing
export const OrderLoadingHeading = styled("h3")`
  text-transform: uppercase;
  letter-spacing: 0.2px;
  font-size: 18px;
  font-weight: 400;
  color: ${themeGet("colors.blueDarker")};
  text-align: center;
  z-index: 13;
  opacity: 1;
`;

export const GeneralLoading = ({ children }) => (
  <div
    css={`
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    `}
  >
    <OrderLoading>
      <BlueDarkerBounce />
      <BlueDarkerBounce className="second" />
    </OrderLoading>
    <div
      css={`
        margin-top: 8px;
      `}
    >
      <OrderLoadingHeading>{children}</OrderLoadingHeading>
    </div>
  </div>
);

export const CartLoading = styled("div")`
  display: inline-block;
  width: 32px;
  height: 32px;

  &:after {
    content: " ";
    display: block;
    width: 20px;
    height: 20px;
    margin: 1px;
    border-radius: 50%;
    border: 5px solid #fff;
    border-color: #6574cd transparent #6574cd transparent;
    animation: ${load} 1.2s linear infinite;
  }
`;

export const LoginLoading = styled(CartLoading)`
  &: after {
    content: " ";
    display: block;
    width: 20px;
    height: 20px;
    margin: 1px;
    border-radius: 50%;
    border: 5px solid #fff;
    border-color: #fff transparent #fff transparent;
    animation: ${load} 1.2s linear infinite;
  }
`;

export const FullScreenContainer = styled(FlexRow)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.9;
  background-color: #fff;
  z-index: 10;
`;



// WEBPACK FOOTER //
// ../shop_main/components/loading/style.js